import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ImgWebp } from '../../components/commons/ImgWeb';
import image404 from '../../assets/images/404.png';
import './Page404.scss';
import { CustomMUIButton } from '../../components/commons/buttons/CustomMUIButton';
import { ButtonClassNames, GlobalRouteNames } from '../../models/Common';

export const Page404 = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleButton = () => {
    history.push(GlobalRouteNames.HomePage);
  };

  return (
    <div className="page-404 page">
      <div className="page-404__container container">
        <ImgWebp fallback={image404} alt="page not found" className="page-404__image" />
        <div className="page-404__content">
          <h1>{t('404.pageNotFound')}</h1>
          <div className="page-404__content__text-btn-container">
            <p>{t('404.itLooksLikePageDoesNotExist')}</p>
            <CustomMUIButton
              label={t('buttons.goBackToMainPage')}
              handleClick={handleButton}
              className={ButtonClassNames.PrimaryFulfilled}
              isBold
            />
          </div>
        </div>
      </div>
    </div>
  );
};
